/**
*
* useFilterParticipants
*
*/

import { useCallback } from 'react';
import sameRole from 'utils/sameRole.js';
import useCurrentRole from 'containers/User/useCurrentRole.js';
import { FILTER_PARTICIPANTS_CURRENT, FILTER_PARTICIPANTS_OTHER } from './constants.jsx';

function useFilterParticipants() {
  const role = useCurrentRole();

  const filterParticipants = useCallback((participants, filterFlags) => participants.filter((p) => {
    if ((filterFlags & FILTER_PARTICIPANTS_OTHER) && sameRole(p, role)) {
      return false;
    }
    return !((filterFlags & FILTER_PARTICIPANTS_CURRENT) && (p.archived || p.isDeleted));
  }), [role.uniqueId]); // eslint-disable-line react-hooks/exhaustive-deps

  return filterParticipants;
}

export default useFilterParticipants;
